<app-button-bg class="header" img="/assets/img/game/call-file-bg.svg" br="5em">
  <div class="btn-inside">
    <div class="right-btn-part">
      <div class="close-btn" (click)="onCloseClick()"></div>
      <div class="text">Call File</div>
    </div>
    <img class="pmi-logo" src="/assets/img/game/pmi-logo.svg">
  </div>
</app-button-bg>
<div class="content">
  <div class="left-column"></div>
  <app-shop-card [singleView]="true" [shopId]="storeId"></app-shop-card>
  <div class="right-column"></div>
</div>
